module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.cfabf0c.eot";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Regular.eot
// module id = 77w+
// module chunks = 3